(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {

  const blogHandle = document.getElementById('blogHandle').value;
  const isVaultMember = document.getElementById('isVaultMember').value;
  const vaultInfoModal = new bootstrap.Modal('#vaultInfoModal');

  if (blogHandle == 'vault-news' && isVaultMember == 'false') {
    vaultInfoModal.show();
  }

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // set both currency pickers to whatever is already set as cart currency in Shopify
  const cartCurrency = window.Shopify.currency.active;
  const currencyPickers = Array.from(document.querySelectorAll('.currency-picker'));
  currencyPickers.forEach((picker) => {
    picker.value = cartCurrency;
  })

  // handle currency picker changes
  currencyPickers.forEach((picker) => {
     picker.addEventListener('change', (e) =>{
      currencyCode = e.target.value;    
      if (currencyCode == 'USD') {
        location = 'https://thirdmanrecords.com';
      } else if (currencyCode == 'GBP') {
        location = 'https://thirdmanstore.co.uk/?currency=GBP';
      } else if (currencyCode == 'EUR') {
        location = 'https://thirdmanstore.co.uk/?currency=EUR';
      } else {
        return;
      }
    });
  })

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  const heroCarousel = document.querySelector('#heroCarousel')

  const autoplay = document.getElementById('autoplay').value;
  let ride = "false";
  if (autoplay) { let ride = "carousel" };

  const interval = Number(document.getElementById('interval').value) * 1000;

  const carousel = new bootstrap.Carousel(heroCarousel, {
    interval: interval,
    touch: true,
    ride: ride,
    pause: "hover"
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const urlParams = new URLSearchParams(window.location.search);
  const searchType = urlParams.get('type');
  
  addEventListener("DOMContentLoaded", (e) => {

    const searchTypeInput = document.getElementById('mainSearchType');
    const searchResultsTypeHeading = document.getElementById('searchResultsTypeHeading');
    console.log('searchTypeInput', searchTypeInput);
    
    if (searchType == 'article') {
      console.log('searchType == article');
      searchTypeInput.value = 'article';
      searchResultsTypeHeading.innerHTML = 'in News Articles';
    }

  })



  } catch(e) { console.error(e); }
})();
})();
